import { createSelector } from 'reselect';

const selectAllRoles = state => state.roles;

/// ROLES

export const selectIsFetchingRoles = createSelector(
    [selectAllRoles],
    roles => roles.isFetchingRoles
)

export const selectRoles = createSelector(
    [selectAllRoles],
    roles => roles.roles
)

export const selectRolesOnPage = createSelector(
    [selectAllRoles],
    roles => roles.rolesOnPage
)

export const selectSearchRolesQuery = createSelector(
    [selectAllRoles],
    roles => roles.searchRolesQuery
)

export const selectNumRoles = createSelector(
    [selectAllRoles],
    roles => roles.numRoles
)

export const selectSelectedRoles = createSelector(
    [selectAllRoles],
    roles => roles.selectedRoles
)